import {
  IBookCoworkingOptions,
  IBookCoworkingResponse200,
  IBookCoworkingResponse400,
  fetchBookCoworking,
} from '../repositories/coworking/v1/book-coworking';

import { useFetch } from './useFetch';

export function useFetchBookCoworking() {
  return useFetch<
    IBookCoworkingResponse200,
    IBookCoworkingResponse400,
    Omit<IBookCoworkingOptions<IBookCoworkingResponse200, IBookCoworkingResponse400>, 'httpApi'>
  >(fetchBookCoworking, 'Ошибка при запросе на бронирование коворкинга"');
}
